import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function CredibilitySection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-1">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-200 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-2">
        <p className="text-xl md:text-2xl leading-relaxed font-semibold text-white" data-id="element-3">
          Esto no es información inventada.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-4">
          Cada hack en este eBook está basado en regulaciones reales del IRS —
          publicadas, documentadas, y accesibles para cualquiera que sepa dónde
          buscar.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-5">
          El problema nunca fue que no existieran. El problema fue que nadie te
          las tradujo.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-6">
          No solo al español. Sino a tu realidad — la del trabajador que no
          tiene CPA, no tiene abogado tributario, y no tiene tiempo para leer
          publicaciones del Departamento del Tesoro.
        </p>

        <div className="bg-navy-light p-6 md:p-8 rounded-xl border-l-4 border-gold-primary shadow-lg mt-8" data-id="element-7">
          <p className="text-xl md:text-2xl font-bold text-gold-primary" data-id="element-8">
            Eso es exactamente lo que este eBook hace.
          </p>
        </div>
      </div>
    </section>;
}